// extracted by mini-css-extract-plugin
export default {"scBox":"SortColumn_scBox__gtEQ0","scIcon":"SortColumn_scIcon__msV4M"};